import { render, staticRenderFns } from "./system_role_list.vue?vue&type=template&id=1b97c272&scoped=true"
import script from "./system_role_list.vue?vue&type=script&lang=js"
export * from "./system_role_list.vue?vue&type=script&lang=js"
import style0 from "./system_role_list.vue?vue&type=style&index=0&id=1b97c272&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97c272",
  null
  
)

export default component.exports